import i18n from "@/i18n/i18n";
import { getSupportedVenueData } from "@/types/supported-venue";
import { t } from "i18next";
import { useMemo, useState } from "react";
import Toast from "@/components/toast/toast";
import { MapImageMarker } from "./image-marker";
// import { isVenueSupported } from "@/const/venue_model/venue_model_config";
import {
  isVenueSupported,
  getVenueModelConfigByVenueCode,
  getVenueIdByVenueCode,
  getBaseUrl,
} from "src/utils/map-util";
import { useExplorationStore } from "@/store/explorationStore";
import { useNavigate } from "react-router-dom";
import { MapVideoMarker } from "./video-marker";

export const VenueMarker = ({
  refCallback,
  onClickMarker,
}: {
  refCallback?: (
    marker: google.maps.marker.AdvancedMarkerElement | null,
    id: string,
  ) => void;
  onClickMarker: Function;
}) => {
  const setCurrentSplat = useExplorationStore((state) => state.setCurrentSplat);
  const setCurrentVenue = useExplorationStore((state) => state.setCurrentVenue);
  const setCurrentLevel = useExplorationStore((state) => state.setCurrentLevel);
  let navigate = useNavigate();

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("Coming Soon");
  const toastDuration = 3000;

  const showComingSoonToast = (venueName: any) => {
    setToast(true);
    setToastMessage(venueName["en"] + " Coming Soon");
    setTimeout(() => setToast(false), toastDuration);
  };

  const BASE_URL = getBaseUrl();

  const rawVenueData = getSupportedVenueData();
  const venueData = useMemo(() => {
    return rawVenueData.map((venue) => {
      const translatedFeatures = venue.features.map((feature: any) => {
        const translationKey = feature.properties.name;
        const translatedName = t(translationKey);

        return {
          ...feature,
          properties: {
            ...feature.properties,
            name: translatedName,
          },
        };
      });

      return {
        ...venue,
        features: translatedFeatures,
      };
    });
  }, [rawVenueData, t, i18n.language]);

  const handleClick = (venueCode: string, venueName: string) => {
    if (!isVenueSupported(venueCode)) {
      showComingSoonToast(venueName);
      return;
    }

    setCurrentVenue(venueCode);

    // inform flutter
    onClickMarker(venueCode, venueName);

    const venueModelConfig = getVenueModelConfigByVenueCode(venueCode);
    if (venueModelConfig) {
      // setCurrentSplat(BASE_URL + venueModelConfig.baseUrl + venueModelConfig.mainSplat);
      setCurrentSplat(
        BASE_URL + venueModelConfig.folderPath + venueModelConfig.mainSplat,
      );
      if (venueModelConfig.floor) {
        const floorlist = venueModelConfig.floor.map((f) => f.name);
        if (floorlist) {
          const defaultFloor = venueModelConfig.floor.find(
            (f) => f.lcMapId === venueModelConfig.defaultLcMapId,
          );
          setCurrentLevel(defaultFloor?.name ?? floorlist[0]);
        }
      }
    }

    navigate(`/explorationFlutter?venue=${venueCode}`);
  };

  return (
    <>
      {toast && (
        <Toast
          message={toastMessage}
          duration={toastDuration}
          centered
        />
      )}
      {venueData &&
        venueData.map((data, index) =>
          data.features.length > 0 &&
            data.features[0].properties.modelPreviewVideo &&
            data.features[0].properties.modelPreviewVideo.length > 0 ? (
            <MapVideoMarker
              key={data.features[0].properties.code}
              id={data.features[0].properties.code}
              position={data.center as google.maps.LatLng}
              videoSource={data.features[0].properties.modelPreviewVideo}
              onClick={(code: string) =>
                handleClick(code, data.features[0].properties.modelName)
              }
              refCallback={refCallback}
            />
          ) : (
            <MapImageMarker
              key={data.features[0].properties.code}
              id={data.features[0].properties.code}
              coordinate={data.center as google.maps.LatLng}
              onClick={(code: string) =>
                handleClick(code, data.features[0].properties.modelName)
              }
              imageSource={"/assets/icon_venue_marker.svg"}
              refCallback={refCallback}
              isMyMarker={false}
            />
          ),
        )}
    </>
  );
};
